import type { TaskStep } from '@tailorcast/shared-types';
import { StepDetail } from './StepDetail';

interface StepsListProps {
  steps: TaskStep[];
  taskId: string;
}

export function StepsList({ steps, taskId }: StepsListProps) {
  if (steps.length === 0) {
    return <div className="text-sm text-gray-500">No steps generated yet.</div>;
  }

  return (
    <div className="space-y-2">
      {steps.map((step) => (
        <StepDetail key={step.id} step={step} taskId={taskId} />
      ))}
    </div>
  );
}
